import { queryKey } from 'Shared/const/queryKey';
import { useSDQuery } from 'viewup-lib/react';

export const useGetPenaltyInfo = (nblogAccountUuid: string) => {
  const queryResult = useSDQuery({
    ...queryKey.posting.penaltyInfo({ accountUuid: nblogAccountUuid }),
    enabled: !!nblogAccountUuid,
    gcTime: 5000,
    select: (data) => {
      return {
        ...data,
        hasPenalty: data.isSuspended !== true && data.penaltyCount > 0,
      };
    },
    staleTime: 5000,
  });

  return queryResult;
};
